import React, { Component } from 'react'

import { Link } from 'react-router'

import AutoComplete from 'material-ui/AutoComplete';

export default class Combobox extends Component{
	state = {
    searchText: '',
  };

  handleUpdateInput = (searchText) => {
    this.setState({
      searchText: searchText,
    });
  };
	componentDidMount(props){
		if (this.state.searchText){
			this.handleUpdateInput('')
		}
		if (!this.props.defaultValue) return;
		this.setState({
      searchText: this.props.defaultValue,
    });
	}
	render(){
		let { props } = this

		return(
			<div className="combobox" style={{display: "flex", height:"35px"}}>
				<div className="icon">
					{(props.text && !props.unable)?
						<Link
							to={props.link}
							style={{
								textDecoration: 'none'
							  , color: 'inherit'
							  , position: "relative"
							  , top: props.label?"16px":"6px"
							  , marginRight: "20px"
							}}
						>
							{props.icon}
						</Link>
						:
						<div
							style={{
								position: "relative"
							  , top: "6px"
							  , marginRight: "20px"
							}}
						>
							{props.icon}
						</div>
					}
				</div>
				<div className="textfield">
					{(!props.text || props.unable)?
						<div>
							<AutoComplete
								filter={AutoComplete.caseInsensitiveFilter}
								hintText={(props.hintText)?props.hintText:""}
								hintStyle={{fontStyle:"italic", fontSize: "14px", top:"15px"}}
								errorText={props.errorText || ""}
								underlineStyle={{
								  borderBottom: "0px solid #b0bec4"
								}}
								menuStyle={{overflowY:"auto", maxHeight:"50vh"}}
								fullWidth={true}
								disabled={props.noDelete}
								onUpdateInput={this.handleUpdateInput}
								style={{
									width: "370px"
								  , position: "relative"
								  , top: "-13px"
								}}
								inputStyle={{
									fontSize: "14px"
								  , width: "370px"
								  , height:"55px"
								}}
								searchText={this.state.searchText}
								dataSource={props.dataSource}
								onNewRequest={props.onChange}
								onBlur={props.onBlur || null}
							/>
						</div>
						:
						<div>
							{props.label &&
								<p style={{fontSize:"12px", position:"relative", top:"-8px", marginTop:"-0px", color:"rgb(200,200,200)", fontWeight:"10"}}>
									{props.label}
								</p>
							}
							<Link
								to={props.link}
								style={{
									textDecoration: 'underline'
								  , color: 'inherit'
								  , cursor: "pointer"
								  , position: "relative"
								  , top: props.label?"-15px":"5px"
								}}
							>
								<p style={{textAlign:"left", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth:"350px", overflow: "hidden", margin:"0"}}>{props.text}</p>
							</Link>
						</div>
					}
				</div>
				{!props.noDelete && <div className="delete">
					<i
						className="material-icons"
						style={{
							height: "16px",
							cursor: "pointer",
							display: (props.text && !props.unable)?"":"none",
							position: "relative",
							top: props.label?"11px":"3px",
							color: "grey",
							fontSize: "24px"
						}}
						onClick={() =>{
							props.onChange(undefined);
							this.setState({ searchText: "" });
						}}
					>
						close
					</i>
				</div>}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/Combobox.js